import styled from "styled-components";

// Migrated from deleted HalfCardHOC.scss:
// - position: fixed; left/bottom/right: 0
// - z-index: $overlay-zindex + 1 (399 + 1)
// - background: $white → theme background_Primary
// borderRadius and safe-area paddingBottom are DLS additions for the dineout half-card overlay.
const HALF_CARD_Z_INDEX = 400;

export const HalfCardContainer = styled.div(({ theme }) => ({
    position: "fixed",
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: HALF_CARD_Z_INDEX,
    background: theme.colors[theme.colorMode].background_Primary,
    borderRadius: `${theme.cornerRadius.medium} ${theme.cornerRadius.medium} 0 0`,
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,
    "@supports (-webkit-touch-callout: none)": {
        "@supports (padding-bottom: env(safe-area-inset-bottom))": {
            paddingBottom: `calc(max(env(safe-area-inset-bottom) - ${theme.spacing.xSmall}, ${theme.spacing.medium}))`,
        },
    },
}));
